import { useEffect, useState } from 'react';
import { sortByLabel } from '../config/columns';

/**
 * Loads option lists for FK selects.
 * spec: { name: { service, labelKey, valueKey='id' } }
 * Returns { name: [{ value, label }] }, alphabetized by label.
 */
export default function useLookups(spec) {
  const [lookups, setLookups] = useState({});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const out = {};
      await Promise.all(
        Object.entries(spec).map(async ([name, cfg]) => {
          try {
            const rows = await cfg.service.list();
            out[name] = sortByLabel(rows.map((r) => ({
              value: r[cfg.valueKey || 'id'],
              label: typeof cfg.labelKey === 'function' ? cfg.labelKey(r) : r[cfg.labelKey],
            })));
          } catch {
            out[name] = [];
          }
        })
      );
      if (!cancelled) setLookups(out);
    })();
    return () => {
      cancelled = true;
    };
  }, []); // eslint-disable-line

  return lookups;
}
